export const initialCachedEndpointState = {
	isFetching: false,
	wasFetched: false,
	fetchedOnce: false,
	fetchError: null,
};
